import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ARGameScreen from '../components/ARGameScreen';

export default function ARGamePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // URL 파라미터 또는 state에서 게임 정보 가져오기
  const { 
    nickname,
    roomCode = '',
    userRank = 1,
    initialScore = 0
  } = location.state || {};
  
  // 닉네임 우선 사용: location.state의 nickname > user의 username > 기본값
  const displayName = nickname || user?.username || '플레이어';

  return (
    <ARGameScreen
      userName={displayName}
      userRank={userRank}
      initialScore={initialScore}
      roomCode={roomCode}
    />
  );
}